import { render, staticRenderFns } from "./PFICreditLimitOverview.vue?vue&type=template&id=34bd81dc&scoped=true&"
import script from "./PFICreditLimitOverview.vue?vue&type=script&lang=js&"
export * from "./PFICreditLimitOverview.vue?vue&type=script&lang=js&"
import style0 from "./PFICreditLimitOverview.vue?vue&type=style&index=0&id=34bd81dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bd81dc",
  null
  
)

export default component.exports